import { Grid, Paper, Skeleton, Divider } from '@mui/material';

export const FundraiserSkeletons = () => {
  return (
    <>
      {Array.from({ length: 6 }).map((_, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <Grid item xs={12} sm={6} md={4} key={`skeleton-${idx}`}>
          <Paper>
            <Grid container py={2} px={1.5}>
              <Grid item xs={12}>
                <Skeleton variant='text' width='60%' height={28} />
              </Grid>
              <Grid item xs={12}>
                <Skeleton variant='text' width='40%' height={40} />
              </Grid>
              <Grid item xs={12} mt={2}>
                <Skeleton variant='rectangular' height={140} />
              </Grid>
              <Grid item xs={12} mt={1}>
                <Divider />
              </Grid>
              <Grid item xs={12} mt={1}>
                <Grid container justifyContent='space-between' alignItems='center'>
                  <Skeleton variant='text' width='40%' height={20} />
                  <Skeleton variant='text' width='30%' height={20} />
                </Grid>
              </Grid>
              <Grid item xs={12} mt={1}>
                <Divider />
              </Grid>
              <Grid item xs={12} mt={1}>
                <Skeleton variant='text' width='30%' height={24} />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      ))}
    </>
  );
};
